import { render, staticRenderFns } from "./AudioCustomePc.vue?vue&type=template&id=2c807515&scoped=true&"
import script from "./AudioCustomePc.vue?vue&type=script&lang=js&"
export * from "./AudioCustomePc.vue?vue&type=script&lang=js&"
import style0 from "./AudioCustomePc.vue?vue&type=style&index=0&id=2c807515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c807515",
  null
  
)

export default component.exports